var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 35V31.6667C28.3334 29.8986 27.631 28.2029 26.3808 26.9526C25.1306 25.7024 23.4349 25 21.6668 25H8.33342C6.56531 25 4.86961 25.7024 3.61937 26.9526C2.36913 28.2029 1.66675 29.8986 1.66675 31.6667V35",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 18.3333C18.6818 18.3333 21.6666 15.3486 21.6666 11.6667C21.6666 7.98477 18.6818 5 14.9999 5C11.318 5 8.33325 7.98477 8.33325 11.6667C8.33325 15.3486 11.318 18.3333 14.9999 18.3333Z",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3333 35.0001V31.6668C38.3322 30.1897 37.8405 28.7548 36.9355 27.5873C36.0305 26.4199 34.7635 25.5861 33.3333 25.2168",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 5.2168C28.1008 5.58397 29.3718 6.41797 30.2795 7.58731C31.1871 8.75666 31.6798 10.1948 31.6798 11.6751C31.6798 13.1554 31.1871 14.5936 30.2795 15.7629C29.3718 16.9323 28.1008 17.7663 26.6667 18.1335",
    stroke: "#374151",
    strokeWidth: 3.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.b0ecf2535ea2c7d05a80997c95aa453f.svg";
export { ForwardRef as ReactComponent };